import AdminSession from './admin-session';

export default AdminSession;
